import React, { useContext, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useQuery, useMutation, gql } from "@apollo/client";

import { Link, useNavigate } from "react-router-dom";

import ThemeContext from "../../../../../context/ThemeContext";
import UserContext from '../../../../../context/UserContext';
import { TabView, TabPanel } from 'primereact/tabview';
import { InputText } from "primereact/inputtext";
import { InputNumber } from 'primereact/inputnumber';
import { Fieldset } from 'primereact/fieldset';
import { RadioButton } from "primereact/radiobutton";
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
import HtlFloorPlan from "./HtlFloorPlan";
//import HtlPeriods from "./HtlPeriods";

import {IntlProvider, FormattedMessage, FormattedNumber, useIntl} from 'react-intl'
import messages from '../../../../../lang/LangGlb';
import { InputSwitch } from "primereact/inputswitch";


//tablo olmadigi icin dprsub iki kere cagiriliyor yedine hesap plani gelecek

const GET_POST = gql`
query MyQuery(
    $dprMainCode: String
    $dprSubCode: String
    $ownFirmCode: String
    $ownFirmSubCode: String
    ) {
        tbl_dpr_sub(where: {
        dpr_main_code: {_eq: $dprMainCode}
        dpr_sub_code: { _eq: $dprSubCode }
        firm_main_code: { _eq: $ownFirmCode }
        firm_sub_code: { _eq: $ownFirmSubCode }
    }) {
        dpr_main_code
        dpr_sub_code
        dpr_sub_name
        dpr_sub_type
        dpr_sub_grp_code
        active
  
 

  }
  tbl_dpr_sub_coop(where: {
    dpr_sub_code_n: {_eq: $dprSubCode}}) {
        dpr_main_code_n
        dpr_sub_code_n
        dpr_sub_name_n
        dpr_sub_type_n
       
       
   
    
  }
  
}
`;




const INSERT_SEA = gql`
  mutation InsertRules(
    $rulPernId: String
    $rulSubId: String
    $ownFirmCode: String
    $ownFirmSubCode: String
    $rulesName: String   
    $ruleType: String
    $active: Boolean
    $lang: String

   
    
  ) {
    insert_tbl_dpr_sub

    (
      objects: {
        firm_main_code: $ownFirmCode,
        firm_sub_code: $ownFirmSubCode,
        dpr_main_code: $rulPernId,
        dpr_sub_code: $rulSubId,
        dpr_sub_type: $ruleType,
        dpr_sub_name: $rulesName,
        active: $active,
        lang: $lang,
        
       
       

        
      }
    ) {
      affected_rows
    }
  }
`;


const GET_RULES_CLS = gql`
  query MyQuery( $lang: String, $defType: String, $ruleClass2: String) {
    tbl_gnl_def(
      where: {        
        lang: { _eq: $lang },
        type: { _eq: $defType },
        
       
      }
    ) {
      lang
      type
      code
      name
      opt_1
    }
  }
`;



const UPDATE_RULES = gql`
mutation UpdateRules(
    $rulPernId: String
    $rulSubId: String
    $ownFirmCode: String
    $ownFirmSubCode: String
    $rulesName: String   
    $ruleType: String
    $active: Boolean
    
   
    
  ) {
    update_tbl_dpr_sub(
      where: {
        dpr_sub_code: { _eq: $rulSubId }
        dpr_main_code: { _eq: $rulPernId }
        firm_main_code: { _eq: $ownFirmCode }
        firm_sub_code: { _eq: $ownFirmSubCode }
      }
      _set: {
        
        dpr_sub_type: $ruleType
        dpr_sub_name: $rulesName
        active: $active
       
       
      }
    ) {
      affected_rows
    }
  }
`; 

const UPDATE_ID_SEQ2 = gql`
mutation UpdateIdSeq2($type: String!) {
  update_tbl_id_SEQ(
    where: { type: { _eq: $type } }
    _inc: { id_seq: 1 }
  ) {
    returning {
      id_seq
    }
  }
}
`;




//Building Plan Form

const HtlCaseSubEdit = () => {

   const {varCode, setVarCode} = useContext(ThemeContext);
   const {varCode2, setVarCode2} = useContext(ThemeContext);
   const {varCode8, setVarCode8} = useContext(ThemeContext);
   const {varCode9, setVarCode9} = useContext(ThemeContext);
   const {varCode10, setVarCode10} = useContext(ThemeContext);
   const {varCode11, setVarCode11} = useContext(ThemeContext);
   const {varCode12, setVarCode12} = useContext(ThemeContext);
  const {userName, setUserName} = useContext(ThemeContext);
  const { users } = useContext(UserContext);

  const ownFirmCode = users.firmcode;
  const ownFirmSubCode = users.subfirmcode;
  const ownFirmSubType = users.usertype;
  

  const lang = users.userLang;

 

  

     
   
  
  
  const { loading, error, data, refetch } = useQuery(GET_POST, {
    variables: { dprMainCode: varCode, ownFirmCode: ownFirmCode, ownFirmSubCode: ownFirmSubCode, dprSubCode: varCode8  },
  });


  const firmData = data && data.tbl_dpr_sub ? data.tbl_dpr_sub[0] : null;
  const firmData2 = data && data.tbl_floor_map ? data.tbl_floor_map[0] : null;
 

  const [updateRulesSub] = useMutation(UPDATE_RULES);
  const [updateIdSeq2] = useMutation(UPDATE_ID_SEQ2); 
  const [InsertSeason] = useMutation(INSERT_SEA);

  const [displayBasic, setDisplayBasic] = useState(false);

  
  
  
 // const [firmCode, setFirmcode] = useState(firmData ? firmData.firm_main_code_n : "");
 const [firmCode, setFirmCode] = useState('');
 const [firmName, setFirmName] = useState(""); 
 const [rulSubId, setRulSubnId] = useState(firmData ? firmData.dpr_sub_code : "");  
  const [rulPernId, setRulPernId] = useState(firmData ? firmData.dpr_main_code : ""); 
  const [rulesName, setRulesName] = useState(firmData ? firmData.dpr_sub_name : ""); 
  const [ruleType, setRulesType] = useState(firmData ? firmData.dpr_sub_type : ""); 
  const [active, setActive] = useState(firmData ? firmData.active :true); 
  const [firmTrg, setFirmTrg] = useState(""); 
 

  const [openModal, setOpenModal] = useState(false);
  const [modalParam, setModalParam] = useState('');
  const [verim, setVerim] = useState('T0002');
  const {theme, setTheme} = useContext(ThemeContext);



  const [activeTab, setActiveTab] = useState(0);
  const [activeTabS, setActiveTabS] = useState(9);

  const handleTabChange = (index) => {
    setActiveTab(index);
  };

  const handleTabChangeS = (index) => {
    setActiveTabS(index);
  };



  
  const intl = useIntl();
  const currentLocale = users.userLang || localStorage.getItem('lang') || 'en';
  const rule_detail_title = messages[currentLocale].rule_detail_title;
  const rule_id_title = messages[currentLocale].rule_id_title;
  const rule_class_title = messages[currentLocale].rule_class_title;
  const rule_class_name_title = messages[currentLocale].rule_class_name_title;
  const select_rule_type_hint = messages[currentLocale].select_rule_type_hint;
  const new_premises_btn = messages[currentLocale].new_premises_btn;
  const currentPageReportTemplate = messages[currentLocale].currentPageReportTemplate;
  const statusrec = messages[currentLocale].statusrec;
  const activerec = messages[currentLocale].activerec;
  const inactiverec = messages[currentLocale].inactiverec;
  const update = messages[currentLocale].update;
  const new_rule_btn = messages[currentLocale].new_rule_btn;
  const premises_management_title = messages[currentLocale].premises_management_title;
  const rule_grp_id_title = messages[currentLocale].rule_grp_id_title;
  const rule_type_title = messages[currentLocale].rule_type_title;
  const detail = messages[currentLocale].detail;
  const start_date_title = messages[currentLocale].start_date_title;
  const end_date_title = messages[currentLocale].end_date_title;
  


  const { loading: defLoading, error: defError, data: defData } = useQuery(GET_RULES_CLS, {
    variables: {lang: currentLocale, defType: "SCASE" },
  });




  useEffect(() => {
    // newId değeri bağlamdaki yeni değeri yansıtır
    if (firmTrg !== '') {
      // newId güncellendiğinde setFirmCode işlevini çağırarak firmCode'u güncelliyor
    handleinser();  
    
    }
  }, [firmTrg, setFirmTrg]);




  

  useEffect(() => {
    if (firmData) {

        
        setRulSubnId(firmData.dpr_sub_code);  
        setRulPernId(firmData.dpr_main_code);
        setRulesName(firmData.dpr_sub_name);       
        setRulesType(firmData.dpr_sub_type);
        setActive(firmData.active);
   
     
          
    }
  }, [firmData]);




  const handleUpdate = () => {
   
    
    updateRulesSub({
      variables: {
        rulPernId: rulPernId,
        rulSubId: rulSubId,
        ownFirmCode: ownFirmCode,
        ownFirmSubCode: ownFirmSubCode,      
        rulesName: rulesName,        
        ruleType: ruleType,
        active: active,
    //    startDate: new Date(startDate).toLocaleDateString(),
     //   endDate: new Date(endDate).toLocaleDateString(),
   //     fmActive: fmActive,

        
      },
    })
      .then(() => {
        window.alert("Firm updated successfully!");
        refetch();
       
      })
      .catch((error) => {
        console.error("Error updating firm:", error);
      });
  }; 

  const handleUpdateIdSeq = async () => {
    const requiredFields = ['rulesName', 'ruleType' ]; // Required fiels
    const customFieldNames = {
      rulesName: "Offer Name",
    //  ruleClass: "Rules Class",
      ruleType: "Rules Type",

    

    };
    const emptyFields = getEmptyFields(requiredFields, customFieldNames); // Boş alanları kontrol et
  
    if (emptyFields.length === 0) {
      try {
        const { data } = await updateIdSeq2({
          variables: {
            type: 'MFIRM', 
          },
        });
        const updatedIdSeq = data.update_tbl_id_SEQ.returning[0].id_seq;
        console.log(`ID_SEQ güncellendi: ${updatedIdSeq}`);
        setRulSubnId(String(updatedIdSeq));
        setFirmTrg(String(updatedIdSeq));
     //   setIdSeqTrg(updatedIdSeq);
        
        console.log(rulSubId);
        // setVarCode(updatedIdSeq.toString());  
      } catch (error) {
        console.error('Güncelleme hatası:', error);
      }
    } else {
      
      const emptyFieldsMessage = `Boş Alanları Doldurun: ${emptyFields.join(', ')}`;
     // console.log(emptyFieldsMessage);
      window.alert(emptyFieldsMessage);
    }
  };

  const getEmptyFields = (requiredFields, customFieldNames) => {
    const emptyFields = [];
  
    // Boş olan alanları bul
    for (const field of requiredFields) {
      if (!eval(field)) {
        emptyFields.push(customFieldNames[field]);
      }
    }
  
    return emptyFields;
  };

  const handleinser = () => {
    InsertSeason({
      variables: {

        ownFirmCode: ownFirmCode,
        ownFirmSubCode: ownFirmSubCode,
        rulPernId: varCode,
        rulSubId: rulSubId,        
        rulesName: rulesName,     
        ruleType: ruleType, 
        lang: currentLocale,
        active: active,

    
    
           
      },
    })
      .then(() => {
        window.alert("Rules insert successfully!");
        setVarCode8(rulSubId);
      })
      .catch((error) => {
        console.error("Error insert Rules:", error);
      });
  };


  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error.message}</p>;

      
  const onClick = () => {
    setVarCode11(ruleType); //EBO
    setVarCode8(rulSubId);
    setDisplayBasic(true);
    
  };

  const onClick2 = () => {
   // setVarCode10(0);  
    setVarCode11(ruleType); //EBO
    setVarCode10(0); //EBO
    setDisplayBasic(true);
    
  };
  
  const onHide = () => {
    setDisplayBasic(false);
    refetch();
  };


  const getStatusLabel = (rowData) => {
    const statusClass = rowData.active
      ? "text-purple-800 font-bold text-sm"
      : "text-gray-500 font-bold text-sm";
  
    return (
      <div className={statusClass}>
      {rowData.active ? (
        <FormattedMessage id={activerec} />
      ) : (
        <FormattedMessage id={inactiverec} />
      )}
    </div>
    );
  };


  const rulesClasstems = defData && defData.tbl_gnl_def
  ? defData.tbl_gnl_def.map(item => ({
      label: item.name,
      value: item.code,
      name: item.name, 
    }))
  : [];






  return (

    <div className="container -mt-4 mx-auto sm:p-4 ">
      
  
   


         <TabView className="flex m-0 p-0 list-none flex-nowrap" activeIndex={activeTab} onTabChange={(e) => handleTabChange(e.index)}>
           <TabPanel   header={
            <span
              className={`font-bold hover:border-b-2 cursor-pointer  hover:border-purple-500 border-b-2 p-3 focus:outline-none focus:outline-offset-0 focus:shadow-[inset_0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[inset_0_0_0_0.2rem_rgba(147,197,253,0.5)] rounded-t-lg select-none flex items-center relative no-underline overflow-hidden${
                activeTab === 0 ? ' bg-white border-violet-800 text-violet-800 dark:bg-gray-900 dark:border-violet-300 dark:text-violet-300' : 'text-sienna-700'
                
              }`}
            >
              {rule_detail_title}
            </span>
          }
          className="ml-5 flex"
        >
      <div>

    
    <div className=" p-2 ">
         <div className="pt-1"> 
           <Fieldset>
             <p className="my-0  ">
      <div className=" flex gap-4">
          <div className="w-1/5 p-inputtext-sm  flex-column gap-3">
    <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="username">{rule_id_title}</label>
    <InputText className="w-full text-base" 
    id="username" value={rulSubId}
    onChange={(e) => setRulSubnId(e.target.value)}
    readOnly
    />
  </div>



  
  
  <div className="w-1/5 p-inputtext-sm flex-column gap-3">
    <label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="firmname">{rule_class_title}</label>
    <InputText className="w-full text-base" 
    id="firmname" value={ruleType} 
    onChange={(e) => setRulesType(e.target.value)} autoComplete="off"/>
    
  </div>

  <div>
        <label htmlFor="roomClassDropdown" className="font-medium flex  text-gray-700">
        {rule_class_name_title}
       </label>
       <Dropdown
       className="h-11  w-56 rounded-md" // Bu satır eklenmiştir
        style={{ width: '244px' }} 
        dropdownIcon={  <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
         <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
         </svg>}
         value={ruleType}
         options={rulesClasstems}
         onChange={(e) => setRulesType(e.value)}
         placeholder={select_rule_type_hint}
         />

         
         
       </div>

       <div className="mr-2 w-1/8">
    <label htmlFor="firmType" className="block font-medium text-gray-700"> 
      {"Aktif"}
    </label>
    <InputSwitch checked={active} onChange={(e) => setActive(e.value)} />
  </div> 

  
      </div>  
      

  
 
 

  

  <div className="flex gap-3 my-5">

  <div className="w-full p-inputtext-sm  gap-3">
    <label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="firmname">{"Rule Description"}</label>
    <InputText className="w-full text-base" 
    id="firmname" value={rulesName} 
    onChange={(e) => setRulesName(e.target.value)} autoComplete="off"/>
    
  </div>
  
  

  
  
      </div>
      <div className="flex  gap-4 ">
      <div className="w-2/4">
     
  </div>
  <div className="w-2/4">
    <Button
      label={new_premises_btn}
      aria-label="Update"
      className="w-full p-button-sm p-button-outlined bg-purple-900 hover:bg-violet-900 text-white font-semibold rounded-md"
      onClick={onClick2}
    />
  </div>
  <div className="w-2/4">
    <Button
      label={update}
      aria-label="Update"
      className="w-full p-button-sm p-button-outlined bg-purple-900 hover:bg-violet-900 text-white font-semibold rounded-md"
      onClick={handleUpdate}
    />
  </div>
  <div className="w-2/4">
    <Button
      label={new_rule_btn}
      aria-label="Update"
      className="w-full p-button-sm p-button-outlined bg-purple-800 hover:bg-indigo-500 text-white font-semibold rounded-md"
      onClick={handleUpdateIdSeq}
    />
  </div>
</div>

<div>
<Dialog visible={displayBasic} style={{ width: '55vw' }}header={"Floor Plan"} onHide={onHide}>
  <p>
   <HtlFloorPlan/>
  </p>
</Dialog>
</div>
</p>
   </Fieldset>
       </div>
 
       </div>          
  
  </div>


 <p> <DataTable
         value={data.tbl_floor_map }
         scrollable 
         scrollHeight="250px" loading={loading}
         stickyHeader
         stickyTopAt=".layout-topbar"
        

        >
           <Column field="floor_id"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{"Id"}</span>}
           style={{ textAlign: 'left', width: '6rem' }}
          >
          </Column>
          <Column field="build_plan_id"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{rule_grp_id_title}</span>}
           style={{ textAlign: 'left', width: '6rem' }}
          >
          </Column>

          <Column field="facs_code"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{"Code"}</span>}
           style={{ textAlign: 'left', width: '7rem' }}
          >
          </Column>
          <Column field="facs_name"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{rule_type_title}</span>}
           style={{ textAlign: 'left', width: '12rem' }}
          >
          </Column>


          <Column
          header={<span className="font-bold text-sm text-gray-900">{detail}</span>}
          body={(rowData) => (
            <button
              onClick={() => {               
                setVarCode10(rowData.floor_id);  
              //  setVarCode(rowData.sea_id_seq);                          
                onClick();
              
                
              }}
              className="p-1 rounded-full dark:text-gray-600 hover:dark:bg-gray-700 focus:dark:bg-gray-700"
            >
              <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
                <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
              </svg>
            </button>
          )}
          style={{ textAlign: 'center', width: '6rem' }}
        ></Column>
    
        </DataTable></p>    

              </TabPanel>
              <TabPanel   header={
            <span
              className={`font-bold hover:border-b-2 cursor-pointer  hover:border-purple-500 border-b-2 p-3 focus:outline-none focus:outline-offset-0 focus:shadow-[inset_0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[inset_0_0_0_0.2rem_rgba(147,197,253,0.5)] rounded-t-lg select-none flex items-center relative no-underline overflow-hidden${
                activeTab === 1 ? ' bg-white border-violet-800 text-violet-800 dark:bg-gray-900 dark:border-violet-300 dark:text-violet-300' : 'text-sienna-700'
                
              }`}
            >
              {"Rule Premises"}
            </span>
          }
          className="ml-5 flex"
        >
    

              </TabPanel>
            
          </TabView>   
     
    </div>




    
    
    
 
 
);
};

export default HtlCaseSubEdit;
